import { Box, Dialog } from '@material-ui/core';
import HighchartsReact from 'highcharts-react-official';
import highchartsMore from 'highcharts/highcharts-more.js';
import Highcharts from 'highcharts/highstock';
import xRange from 'highcharts/modules/xrange.js';
import React from 'react';
import { COLORS } from '../../../utils/colors';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import EventsTable from '../../../views/Online/components/EventsObjective/EventsObjectiveTableLight';
import { GraphInfo } from './GraphInfo';

highchartsMore(Highcharts);
xRange(Highcharts);

export function AvailabilityConsolidated({ dataAvailabilityConsolidated }) {
  const chartConsolidatedRef = React.useRef(null);
  const chartNodeRef = React.useRef(null);
  const containerRef = React.useRef(null);
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = React.useState(false);
  const [clickedPoint, setClickedPoint] = React.useState(null);
  const [hoverData, setHoverData] = React.useState(null);

  React.useEffect(() => {
    Highcharts.setOptions({
      lang: {
        months: t('months', { returnObjects: true }),
        weekdays: t('weekDays', { returnObjects: true }),
        shortMonths: t('shortMonths', { returnObjects: true }),
      },
    });
  }, []);

  React.useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const resizeObserver = new ResizeObserver(() => {
      if (chartConsolidatedRef.current) {
        chartConsolidatedRef.current.chart.reflow();
      }
      if (chartNodeRef.current) {
        chartNodeRef.current.chart.reflow();
      }
    });

    resizeObserver.observe(container);

    return () => {
      resizeObserver.unobserve(container);
    };
  }, []);

  function onClickDataBar(e) {
    const { x, x2, y, series } = e;
    let point = {};
    point['x'] = x;
    point['x2'] = x2;
    point['y'] = series.chart.yAxis[0].categories[y];
    setClickedPoint(point);
    setOpenDialog(true);
  }

  function onHoverData(e) {
    const { x, x2, y, series } = e;
    let point = [];
    point['x'] = x;
    point['x2'] = x2;
    point['y'] = series.chart.yAxis[0].categories[y];
    let step = series.userOptions.name;
    setHoverData({ ...point, step });
  }

  function processData() {
    if (
      !dataAvailabilityConsolidated ||
      Object.keys(dataAvailabilityConsolidated).length === 0
    )
      return {};
    const { Nodo, Global } = dataAvailabilityConsolidated.Objetivo;
    const { estado } = Global[0];

    let dictDataStackedBarUptime = {};
    dictDataStackedBarUptime['name'] = t('objective.status.uptime');
    dictDataStackedBarUptime['pointWidth'] = 40;
    let arrayDataUptime = [];

    let dictDataStackedBarDowntime = {};
    dictDataStackedBarDowntime['name'] = t('objective.status.downtime');
    dictDataStackedBarDowntime['pointWidth'] = 40;
    let arrayDataDowntime = [];

    let dictDataStackedBarNoMon = {};
    dictDataStackedBarNoMon['name'] = t('objective.status.no-monitoring');
    dictDataStackedBarNoMon['pointWidth'] = 40;
    let arrayDataNoMon = [];

    let dictDataStackedBarPartial = {};
    dictDataStackedBarPartial['name'] = t('objective.status.partial');
    dictDataStackedBarPartial['pointWidth'] = 40;
    let arrayDataPartial = [];

    let dictDataStackedBarEvent = {};
    dictDataStackedBarEvent['name'] = t('objective.status.maintenance');
    dictDataStackedBarEvent['pointWidth'] = 40;
    let arrayDataEvent = [];

    let dictDataStackedBarMarcadoAtentus = {};
    dictDataStackedBarMarcadoAtentus['name'] = t(
      'objective.status.marked-atentus'
    );
    dictDataStackedBarMarcadoAtentus['pointWidth'] = 40;
    let arrayDataMarcadoAtentus = [];

    //Diccionarios y listas para información por nodos
    let dictDataStackedBarUptimeNode = {};
    dictDataStackedBarUptimeNode['name'] = t('objective.status.uptime');
    dictDataStackedBarUptimeNode['pointWidth'] = 20;
    let arrayDataUptimeNode = [];

    let dictDataStackedBarDowntimeNode = {};
    dictDataStackedBarDowntimeNode['name'] = t('objective.status.downtime');
    dictDataStackedBarDowntimeNode['pointWidth'] = 20;
    let arrayDataDowntimeNode = [];

    let dictDataStackedBarNoMonNode = {};
    dictDataStackedBarNoMonNode['name'] = t('objective.status.no-monitoring');
    dictDataStackedBarNoMonNode['pointWidth'] = 20;
    let arrayDataNoMonNode = [];

    let dictDataStackedBarPartialNode = {};
    dictDataStackedBarPartialNode['name'] = t('objective.status.partial');
    dictDataStackedBarPartialNode['pointWidth'] = 20;
    let arrayDataPartialNode = [];

    let dictEventClient = {};
    dictEventClient['name'] = t('objective.status.maintenance');
    dictEventClient['pointWidth'] = 20;
    let arrayEventClient = [];

    let dictEventMarcadoClienteNode = {};
    dictEventMarcadoClienteNode['name'] = t('objective.status.marked-atentus');
    dictEventMarcadoClienteNode['pointWidth'] = 20;
    let arrayMarcadoClienteNode = [];

    Object.keys(estado).map((key) => {
      let dictDataStackedBar = {};

      let dateJson = new Date(estado[key]['fecha_desde'].substring(0, 19));
      let year = dateJson.getFullYear();
      let month = dateJson.getMonth();
      let day = dateJson.getDate();
      let hours = dateJson.getHours();
      let minutes = dateJson.getMinutes();
      let seconds = dateJson.getSeconds();

      let dateJsonEnd = new Date(estado[key]['fecha_hasta'].substring(0, 19));
      let yearEnd = dateJsonEnd.getFullYear();
      let monthEnd = dateJsonEnd.getMonth();
      let dayEnd = dateJsonEnd.getDate();
      let hoursEnd = dateJsonEnd.getHours();
      let minutesEnd = dateJsonEnd.getMinutes();
      let secondsEnd = dateJsonEnd.getSeconds();

      dictDataStackedBar['x'] = Date.UTC(
        year,
        month,
        day,
        hours,
        minutes,
        seconds
      );
      dictDataStackedBar['x2'] = Date.UTC(
        yearEnd,
        monthEnd,
        dayEnd,
        hoursEnd,
        minutesEnd,
        secondsEnd
      );
      dictDataStackedBar['y'] = 0;
      if (estado[key]['nombre'] == 'uptime') {
        dictDataStackedBar['color'] = COLORS.UPTIME;
        arrayDataUptime.push(dictDataStackedBar);
      } else if (estado[key]['nombre'] == 'downtime') {
        dictDataStackedBar['color'] = COLORS.DOWNTIME;
        arrayDataDowntime.push(dictDataStackedBar);
      } else if (estado[key]['nombre'] == 'no monitoreo') {
        dictDataStackedBar['color'] = COLORS.NO_MONITOREO;
        arrayDataNoMon.push(dictDataStackedBar);
      } else if (estado[key]['nombre'] == 'downtime parcial') {
        dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL;
        arrayDataPartial.push(dictDataStackedBar);
      } else if (estado[key]['nombre'] == 'evento cliente') {
        dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE;
        arrayDataEvent.push(dictDataStackedBar);
      } else if (estado[key]['nombre'] == 'marcado atentus') {
        dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS;
        arrayDataMarcadoAtentus.push(dictDataStackedBar);
      }
    });

    let categoriedNode = [];
    Object.keys(Nodo).map((keyNode) => {
      let estadoNodo = Nodo[keyNode][0]['estado'];
      categoriedNode.push(Nodo[keyNode][0]['nodo_nombre']);

      Object.keys(estadoNodo).map((key) => {
        let dictDataStackedBar = {};

        let dateJson = new Date(estadoNodo[key]['fecha_desde']);
        let year = dateJson.getFullYear();
        let month = dateJson.getMonth();
        let day = dateJson.getDate();
        let hours = dateJson.getHours();
        let minutes = dateJson.getMinutes();
        let seconds = dateJson.getSeconds();

        let dateJsonEnd = new Date(estadoNodo[key]['fecha_hasta']);
        let yearEnd = dateJsonEnd.getFullYear();
        let monthEnd = dateJsonEnd.getMonth();
        let dayEnd = dateJsonEnd.getDate();
        let hoursEnd = dateJsonEnd.getHours();
        let minutesEnd = dateJsonEnd.getMinutes();
        let secondsEnd = dateJsonEnd.getSeconds();

        dictDataStackedBar['x'] = Date.UTC(
          year,
          month,
          day,
          hours,
          minutes,
          seconds
        );
        dictDataStackedBar['x2'] = Date.UTC(
          yearEnd,
          monthEnd,
          dayEnd,
          hoursEnd,
          minutesEnd,
          secondsEnd
        );
        dictDataStackedBar['y'] = parseInt(keyNode);
        if (estadoNodo[key]['nombre'] == 'uptime') {
          dictDataStackedBar['color'] = COLORS.UPTIME;
          arrayDataUptimeNode.push(dictDataStackedBar);
        } else if (estadoNodo[key]['nombre'] == 'downtime') {
          dictDataStackedBar['color'] = COLORS.DOWNTIME;
          arrayDataDowntimeNode.push(dictDataStackedBar);
        } else if (estadoNodo[key]['nombre'] == 'no monitoreo') {
          dictDataStackedBar['color'] = COLORS.NO_MONITOREO;
          arrayDataNoMonNode.push(dictDataStackedBar);
        } else if (estadoNodo[key]['nombre'] == 'downtime parcial') {
          dictDataStackedBar['color'] = COLORS.DOWNTIME_PARCIAL;
          arrayDataPartialNode.push(dictDataStackedBar);
        } else if (estadoNodo[key]['nombre'] == 'evento cliente') {
          dictDataStackedBar['color'] = COLORS.EVENTO_CLIENTE;
          arrayEventClient.push(dictDataStackedBar);
        } else if (estadoNodo[key]['nombre'] == 'marcado atentus') {
          dictDataStackedBar['color'] = COLORS.MARCADO_ATENTUS;
          arrayMarcadoClienteNode.push(dictDataStackedBar);
        }
      });
    });
    dictDataStackedBarUptime['data'] = arrayDataUptime;
    dictDataStackedBarDowntime['data'] = arrayDataDowntime;
    dictDataStackedBarNoMon['data'] = arrayDataNoMon;
    dictDataStackedBarPartial['data'] = arrayDataPartial;
    dictDataStackedBarEvent['data'] = arrayDataEvent;
    dictDataStackedBarMarcadoAtentus['data'] = arrayDataMarcadoAtentus;

    dictDataStackedBarUptimeNode['data'] = arrayDataUptimeNode;
    dictDataStackedBarDowntimeNode['data'] = arrayDataDowntimeNode;
    dictDataStackedBarNoMonNode['data'] = arrayDataNoMonNode;
    dictDataStackedBarPartialNode['data'] = arrayDataPartialNode;
    dictEventClient['data'] = arrayEventClient;
    dictEventMarcadoClienteNode['data'] = arrayMarcadoClienteNode;

    let heightNodeChart = 200;
    if (Nodo.length < 3) {
      heightNodeChart = 150;
    } else if (Nodo.length > 5 && Nodo.length < 10) {
      heightNodeChart = 500;
    } else if (Nodo.length > 10) {
      heightNodeChart = 900;
    }

    return {
      chartOptionsStackedBarConsolidated: {
        chart: {
          type: 'xrange',
          height: 80,
        },
        title: null,
        credits: {
          enabled: false,
        },
        yAxis: {
          categories: ['Consolidado'],
          title: {
            text: '',
          },
          labels: {
            useHTML: true,
            style: {
              whiteSpace: 'normal',
            },
            step: 1,
            formatter: function () {
              //use formatter
              return (
                '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' +
                this.value +
                '</div>'
              );
            },
          },
        },
        series: [
          dictDataStackedBarUptime,
          dictDataStackedBarDowntime,
          dictDataStackedBarNoMon,
          dictDataStackedBarPartial,
          dictDataStackedBarEvent,
          dictDataStackedBarMarcadoAtentus,
        ],
        plotOptions: {
          series: {
            borderRadius: '0px',
            borderColor: 'transparent',
            turboThreshold: 30000,
            boostThreshold: 1,
            datalabels: false,
            cursor: 'pointer',
            point: {
              events: {
                click: function (event) {
                  onClickDataBar(this);
                },
                mouseOver: function (event) {
                  onHoverData(this);
                },
              },
            },
          },
          xrange: {
            dataLabels: {
              enabled: false,
            },
            borderRadius: 0,
            grouping: false,
            borderWidth: 0,
            pointPadding: 0,
            borderColor: 'none',
          },
        },
        legend: {
          enabled: false,
        },
        xAxis: {
          type: 'datetime',
          gridLineWidth: 0,
          dateTimeLabelFormats: {
            second: '%l:%M:%S%P',
            minute: '%l:%M%P',
            hour: '%H:%M',
            day: '<br/><b>%e/%b</b>',
            week: '%e. %b',
            month: '%b %y',
            year: '%Y',
          },
          labels: {
            enabled: false,
          },
          visible: false,
        },
      },
      chartOptionsStackedBarNode: {
        chart: {
          type: 'xrange',
          height: heightNodeChart,
        },
        title: null,
        subtitle: null,
        credits: {
          enabled: false,
        },
        xAxis: {
          type: 'datetime',
          gridLineWidth: 0,
          dateTimeLabelFormats: {
            second: '%l:%M:%S%P',
            minute: '%l:%M%P',
            hour: '%H:%M',
            day: '<br/><b>%e/%b</b>',
            week: '%e. %b',
            month: '%b %y',
            year: '%Y',
          },
        },
        yAxis: {
          categories: categoriedNode,
          title: {
            text: '',
          },
          gridLineWidth: 0,
          reversed: true,
          labels: {
            useHTML: true,
            style: {
              whiteSpace: 'normal',
            },
            step: 1,
            formatter: function () {
              //use formatter
              return (
                '<div align="left" style="word-wrap: break-word;word-break: break-all;width:150px">' +
                this.value +
                '</div>'
              );
            },
          },
        },
        plotOptions: {
          series: {
            cursor: 'pointer',
            turboThreshold: 30000,
            boostThreshold: 1,
            point: {
              events: {
                click: function (event) {
                  onClickDataBar(this);
                },
                mouseOver: function (event) {
                  onHoverData(this);
                },
              },
            },
          },
          xrange: {
            dataLabels: {
              enabled: false,
            },
            borderRadius: 0,
            grouping: false,
            borderWidth: 0,
            pointPadding: 0,
            borderColor: 'none',
          },
        },
        series: [
          dictDataStackedBarUptimeNode,
          dictDataStackedBarDowntimeNode,
          dictDataStackedBarNoMonNode,
          dictDataStackedBarPartialNode,
          dictEventClient,
          dictEventMarcadoClienteNode,
        ],
        legend: { enabled: false },
      },
    };
  }

  if (
    !dataAvailabilityConsolidated ||
    Object.keys(dataAvailabilityConsolidated).length === 0
  ) {
    return <Alert severity="info">{t('objective-not-data')}</Alert>;
  }

  const {
    chartOptionsStackedBarConsolidated,
    chartOptionsStackedBarNode,
  } = processData();

  return (
    <Box ref={containerRef} width="100%">
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptionsStackedBarConsolidated}
        ref={chartConsolidatedRef}
        containerProps={{ style: { width: '100%' } }}
      />
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptionsStackedBarNode}
        ref={chartNodeRef}
        containerProps={{ style: { width: '100%' } }}
      />
      <GraphInfo {...hoverData} />
      <Dialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        maxWidth="xl"
        fullWidth
      >
        <EventsTable
          objective={dataAvailabilityConsolidated.Objetivo.Objetivo_Id}
          dates={clickedPoint}
          monitores={dataAvailabilityConsolidated.Objetivo.Monitores}
          paso_critico={dataAvailabilityConsolidated.Objetivo.paso_critico} 
          onClose={() => setOpenDialog(false)}
        />
      </Dialog>
    </Box>
  );
}
